import { useCallback } from "react";
import axiosConfig from "../../axiosConfig";

const useSettingsApi = () => {
  const fetchSettings = useCallback(async () => {
    return axiosConfig.get("settings/get");
  }, []);

  const updateSettings = useCallback(async (payload) => {
    return axiosConfig.post("settings/update", payload);
  }, []);

  return {
    fetchSettings,
    updateSettings,
  };
};

export default useSettingsApi;

